import { Search } from '@transferwise/icons';
import { forwardRef } from 'react';
import '../common/theme.mjs';
import '../common/direction.mjs';
import '../common/propsValues/control.mjs';
import '../common/propsValues/breakpoint.mjs';
import { Size } from '../common/propsValues/size.mjs';
import '../common/propsValues/typography.mjs';
import '../common/propsValues/width.mjs';
import '../common/propsValues/type.mjs';
import '../common/propsValues/dateMode.mjs';
import '../common/propsValues/monthFormat.mjs';
import '../common/propsValues/position.mjs';
import '../common/propsValues/layouts.mjs';
import '../common/propsValues/status.mjs';
import '../common/propsValues/sentiment.mjs';
import '../common/propsValues/profileType.mjs';
import '../common/propsValues/variant.mjs';
import '../common/propsValues/scroll.mjs';
import '../common/propsValues/markdownNodeType.mjs';
import '../common/fileType.mjs';
import '@transferwise/formatting';
import 'clsx';
import 'react-intl';
import '../common/closeButton/CloseButton.messages.mjs';
import { jsx } from 'react/jsx-runtime';
import { Input } from './Input.mjs';
import { InputGroup } from './InputGroup.mjs';

const SearchInput = /*#__PURE__*/forwardRef(function SearchInput({
  shape = 'pill',
  size = Size.MEDIUM,
  disabled,
  className,
  ...restProps
}, ref) {
  return /*#__PURE__*/jsx(InputGroup, {
    addonStart: {
      content: /*#__PURE__*/jsx(Search, {
        size: size === Size.SMALL ? 16 : 24
      }),
      initialContentWidth: size === Size.SMALL ? 16 : 24
    },
    disabled: disabled,
    className: className,
    children: /*#__PURE__*/jsx(Input, {
      ref: ref,
      role: "searchbox",
      inputMode: "search",
      shape: shape,
      size: size,
      ...restProps
    })
  });
});

export { SearchInput };
//# sourceMappingURL=SearchInput.mjs.map
